import(/* webpackMode: "eager" */ "/codebuild/output/src2265874110/src/src/app/global-error.tsx");
